import { IResourceComponentsProps } from '@refinedev/core';
import { AntdInferencer } from '@refinedev/inferencer/antd';

export const FootballFestCategoryShow: React.FC<
  IResourceComponentsProps
> = () => {
  return <AntdInferencer resource="football-fest-category" />;
};
